import { SurveyQuestionType } from 'posthog-js';
import type { Survey } from 'posthog-js';
import type { FC } from 'react';

import { MultipleChoiceQuestion } from './MultipleChoiceQuestion';
import { OpenEndedQuestion } from './OpenEndedQuestion';
import { RatingQuestion } from './RatingQuestion';
import { SingleChoiceQuestion } from './SingleChoiceQuestion';

type Answer = string | string[];

/**
 * Common contract for any component that renders a single PostHog survey
 * question. `value` is `string` for single-choice / open / link / rating,
 * `string[]` for multiple-choice, and `undefined` when unanswered.
 */
export type QuestionRendererProps = {
  question: Survey['questions'][number];
  value: Answer | undefined;
  onChange: (value: Answer) => void;
};

/** A function component that renders one survey question. */
export type QuestionRenderer = FC<QuestionRendererProps>;

/**
 * Default `SurveyQuestionType` → renderer map covering single- and multi-choice.
 * Spread to extend for other types: `{ ...defaultQuestionRenderers, [Open]: ... }`.
 */
export const defaultQuestionRenderers: Partial<Record<SurveyQuestionType, QuestionRenderer>> = {
  [SurveyQuestionType.SingleChoice]: SingleChoiceQuestion,
  [SurveyQuestionType.MultipleChoice]: MultipleChoiceQuestion,
  [SurveyQuestionType.Rating]: RatingQuestion,
  [SurveyQuestionType.Open]: OpenEndedQuestion,
};
